<template>
  <div>
    <ejs-dropdownlist
      :dataSource='hssData'
      :fields='fields'
      @select='selectChanged'
      :placeholder='hssNodePlaceholder'>
    </ejs-dropdownlist>
    <ejs-listview ref='ueListView'
      :dataSource='onlineUes'
      :fields='ueFieldModel'
      @select='ueSelected'>
    </ejs-listview>
    <ejs-pager
      :pageCount='3'
      :pageSize='15'
      :totalRecordsCount='1946'
      @click='pageClicked'>
    </ejs-pager>
  </div>
</template>

<script>
export default {
  name: 'ueList',
  props: {
    hssData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      fields: { text: 'name', value: 'value' },
      hssNodePlaceholder: 'Pls select hss.',
      onlineUes: [],
      ueFieldModel: {
        text: 'nename',
        value: 'neid'
      },
    };
  },
  created() {
    // 查在线的HSS网元
    // this.axios.post('/lte/ems/auth/findElementListByAuth')

  },
  methods: {
    ueSelected() {

    },
    pageClicked(args) {
      const currentPage = args.currentPage;
    },
    selectChanged(args) {
      const hssSelected = args.itemData.value;
      const info = {};
      info.msgid = 11;
      // info.neid =
      info.operation = null;
      const paramMap = new Map();
      paramMap.set('vo', {});
      paramMap.set('info', info);
      // 选择HSS网元时 查该HSS下的所有UE信息
      this.axios.post('lte/ems/subscriber/epcunms/requestCommon').then(res => {
        console.log(res);
        const ueList = res.result;
        // 给ueList赋值
        if(null === ueList || ueList.length <= 0) { return; }
        let imsis = '';
        for (let i = 0; i < ueList.length; i++) {
          imsis += ueList[i].imsi;
          imsis += ',';
        }
        this.queryUeState(ueList, imsis);
      });
    },
    // 先试试不找MME的网元id，还是传HSS的网元id，看是否能下发
    queryUeState(ueList, imsis) {
      const info = {};
      info.msgid = 12;
      // info.neid =
      info.operation = null;
      const paramMap = new Map();
      paramMap.set('vo', {});
      paramMap.set('info', info);
      // 还要查所有在线UE 将不在线的过滤掉
      this.axios.post('lte/ems/subscriber/epcunms/requestCommon').then(res => {
        console.log(res);
        const ueStateList = res.result;
        const displayUeList = [];
        ueList.forEach((ue, index) => {
          const displayUe = {
            linkstatus: 'no-link',
            netype: 'ue',
            neid: 214748364+index,
            nename: ue.imsi,
            ip: ''
          };
          const ueState = ueStateList.find(ueState => (ueState.imsi === ue.imsi));
          if (ueState) {
            displayUe.linkstatus = 'link';
            displayUe.ip = ueState.ip4;
          }
          displayUeList.push(displayUe);
        });
      });
    }
  }
}
</script>

<style>

</style>
